import { AGREEMENT_NOT_SIGNED_ERROR } from "./constants";

/**
 * Map a 403 from the agreements gate to the agreement route param it names.
 *
 * `HasAcceptedAgreements` / `HDAPIPermission` put the outstanding
 * `agreement_type` code in the 403 "detail" (e.g. "40" for the NDA). Where that
 * code sits depends on the view's renderer:
 *
 *   - plain DRF views (accounts, access, portfolios, ...):
 *       {"detail": "40"}
 *   - HDAPI views on HDJSONAPIMixin (rest_framework_json_api renderer):
 *       {"errors": {"detail": "40"}}
 *   - JSON:API spec shape, should the exception handler ever be swapped in:
 *       {"errors": [{"detail": "40", ...}]}
 *
 * Standalone HD only ever produced the first shape, so the interceptor used to
 * read `data.detail` alone and silently skipped the redirect on the monolith's
 * JSON:API views (ZX-15289). Returns the route param ("privacy" | "tou" |
 * "nda") or null when the error is not an unsigned-agreement 403.
 */
const getUnsignedAgreementFromError = error => {
  const data = error?.response?.data;
  if (!data || typeof data !== "object") {
    return null;
  }

  const errors = data.errors;
  let detail = data.detail;
  if (detail === undefined) {
    detail = Array.isArray(errors) ? errors[0]?.detail : errors?.detail;
  }

  if (detail === undefined || detail === null) {
    return null;
  }
  return AGREEMENT_NOT_SIGNED_ERROR[String(detail)] ?? null;
};

export { getUnsignedAgreementFromError };
